// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   1. MAIN LAYOUT & CONTAINERS
   ========================================================================== */
.server-side-datatable {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.server-side-datatable .custom-ag-table-container {
  flex: 1 1;
  min-height: 0;
  margin-left: 4px;
  margin-right: 4px;
}

/* Ensure grid viewports can shrink inside flex containers */
.server-side-datatable .ag-root-wrapper,
.server-side-datatable .ag-root,
.server-side-datatable .ag-body-viewport,
.server-side-datatable .ag-center-cols-viewport {
  min-height: 0 !important;
}

.server-side-datatable .ag-center-cols-viewport {
  margin-bottom: 17px;
}

/* ==========================================================================
   2. TYPOGRAPHY (Global Overrides)
   ========================================================================== */
/* Headers Typography */
.server-side-datatable .ag-header,
.server-side-datatable .ag-header-cell,
.server-side-datatable .ag-header .ag-header-cell-text {
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  line-height: 24px !important;
  font-weight: 500 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

/* Cell Typography */
.server-side-datatable .ag-cell {
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  line-height: 24px !important;
  font-weight: 400 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

/* Menus, Lists, Overlays Typography */
.server-side-datatable .ag-menu,
.server-side-datatable .ag-virtual-list-item,
.server-side-datatable .ag-overlay-loading-center,
.server-side-datatable .ag-overlay-no-rows-center {
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  line-height: 24px !important;
  font-weight: 400 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

/* ==========================================================================
   3. TABLE HEADER
   ========================================================================== */
.server-side-datatable .table-header {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0px;
  margin-top: 0px;
  padding: 0px 8px;
  min-height: 44px;
}

.server-side-datatable .ag-header {
  border-bottom: 2px solid #e0e0e0;
  font-weight: 600;
}

.server-side-datatable .ag-header-cell {
  border-right: 1px solid #e0e0e0;
  padding: 8px 12px;
}

.server-side-datatable .ag-header-cell-text {
  font-weight: 600;
  font-size: 13px;
}

/* Aligns header cell label with its content cells */
.server-side-datatable .ag-header-cell-label {
  padding-left: 4px !important;
}

/* Custom sorted column header styling */
.server-side-datatable .sorted-column-header {
  background-color: #f0f7ff;
  font-weight: 700;
}

/* Sort indicator styling */
.server-side-datatable .ag-header-cell-sorted-asc .ag-header-cell-text::after,
.server-side-datatable .ag-header-cell-sorted-desc .ag-header-cell-text::after {
  margin-left: 4px;
  font-size: 12px;
}

/* Resize handle styling */
.server-side-datatable .ag-header-cell-resize {
  opacity: 0.5;
}

.server-side-datatable .ag-header-cell-resize:hover {
  opacity: 1;
}

/* ==========================================================================
   4. ROWS
   ========================================================================== */
.server-side-datatable .ag-row {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
}

.server-side-datatable .ag-row:hover {
  background-color: #f8f9fa;
}

.server-side-datatable .ag-row.ag-row-selected {
  background-color: #e3f2fd;
}

.server-side-datatable .ag-row.ag-row-selected:hover {
  background-color: #bbdefb;
}

.server-side-datatable .ag-row-last {
  /* No styles provided, keeping selector */
}

/* Duplicate rule from input - likely intended to be removed or specific override */
.server-side-datatable .ag-row:hover {
  background-color: transparent;
}

/* ==========================================================================
   5. CELLS
   ========================================================================== */
.server-side-datatable .ag-cell {
  border-right: 1px solid #f0f0f0;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 1.4;
}

.server-side-datatable .ag-cell.ag-cell-value.text-center {
  justify-content: center;
}

.server-side-datatable .ag-cell.ag-cell-value.text-right {
  justify-content: flex-end;
}

/* ==========================================================================
   6. SELECTION (CHECKBOXES)
   ========================================================================== */
.server-side-datatable .ag-selection-checkbox {
  margin-right: 8px;
}

/* Selection column header alignment with its content cells */
.server-side-datatable .ag-header-cell[col-id="ag-Grid-SelectionColumn"] {
  padding-left: 13px !important;
}

/* ==========================================================================
   7. PAGINATION
   ========================================================================== */
.server-side-datatable .ag-paging-panel {
  border-top: 1px solid #e0e0e0;
  background-color: #fafafa;
  padding: 8px 12px;
}

.server-side-datatable .ag-paging-button {
  border: 1px solid #ddd;
  background-color: white;
  margin: 0 2px;
  border-radius: 3px;
  padding: 4px 8px;
  font-size: 12px;
}

.server-side-datatable .ag-paging-button:hover:not(.ag-disabled) {
  background-color: #f5f5f5;
}

.server-side-datatable .ag-paging-button.ag-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Duplicate rule from input */
.server-side-datatable .ag-paging-panel {
  display: none;
}

/* ==========================================================================
   8. OVERLAYS (LOADING & EMPTY)
   ========================================================================== */
.server-side-datatable .loading-overlay {
  position: relative;
  z-index: 100;
}

.server-side-datatable .ag-overlay-loading-wrapper {
  background-color: rgba(255, 255, 255, 0.9);
}

.server-side-datatable .ag-overlay-loading-center {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.server-side-datatable .ag-overlay-no-rows-wrapper {
  background-color: rgba(255, 255, 255, 0.9);
}

.server-side-datatable .ag-overlay-no-rows-center {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 20px;
  font-size: 14px;
  color: #666;
}

/* ==========================================================================
   9. MENUS & FILTERS
   ========================================================================== */
.server-side-datatable .ag-menu {
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background-color: white;
}

.server-side-datatable .ag-menu-option {
  padding: 8px 12px;
  font-size: 13px;
}

.server-side-datatable .ag-menu-option:hover {
  background-color: #f5f5f5;
}

.server-side-datatable .ag-filter-toolpanel {
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.server-side-datatable .ag-column-drop {
  background-color: #f8f9fa;
  border: 1px dashed #ddd;
  border-radius: 4px;
  padding: 8px;
  margin: 4px 0;
}

/* ==========================================================================
   10. SCROLLBARS (Thinner & Solid Background)
   ========================================================================== */

/* 1. Firefox - Thin scrollbars */
.server-side-datatable .ag-body-viewport,
.server-side-datatable .ag-center-cols-viewport,
.server-side-datatable .ag-body-horizontal-scroll-viewport,
.server-side-datatable .ag-body-vertical-scroll-viewport {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

/* 2. Webkit - Target specific AG Grid viewport elements */
.server-side-datatable .ag-body-viewport::-webkit-scrollbar,
.server-side-datatable .ag-body-horizontal-scroll-viewport::-webkit-scrollbar,
.server-side-datatable .ag-body-vertical-scroll-viewport::-webkit-scrollbar,
.server-side-datatable .ag-center-cols-viewport::-webkit-scrollbar {
  width: 8px !important; /* Vertical scrollbar width */
  height: 8px !important; /* Horizontal scrollbar height */
}

/* 3. The Track */
.server-side-datatable .ag-body-viewport::-webkit-scrollbar-track,
.server-side-datatable
  .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track,
.server-side-datatable
  .ag-body-vertical-scroll-viewport::-webkit-scrollbar-track,
.server-side-datatable .ag-center-cols-viewport::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

/* 4. The Thumb - The draggable part */
.server-side-datatable .ag-body-viewport::-webkit-scrollbar-thumb,
.server-side-datatable
  .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb,
.server-side-datatable
  .ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb,
.server-side-datatable .ag-center-cols-viewport::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

/* 5. Hover State */
.server-side-datatable .ag-body-viewport::-webkit-scrollbar-thumb:hover,
.server-side-datatable
  .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb:hover,
.server-side-datatable
  .ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb:hover,
.server-side-datatable .ag-center-cols-viewport::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 6. Active/Drag State */
.server-side-datatable .ag-body-viewport::-webkit-scrollbar-thumb:active,
.server-side-datatable
  .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb:active,
.server-side-datatable
  .ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb:active,
.server-side-datatable
  .ag-center-cols-viewport::-webkit-scrollbar-thumb:active {
  background: #7d7d7d;
}

/* 7. Corner */
.server-side-datatable .ag-body-viewport::-webkit-scrollbar-corner,
.server-side-datatable
  .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-corner,
.server-side-datatable
  .ag-body-vertical-scroll-viewport::-webkit-scrollbar-corner,
.server-side-datatable .ag-center-cols-viewport::-webkit-scrollbar-corner {
  background: #f1f1f1;
}

/* 8. Force AG Grid scrollbar container sizes */
.server-side-datatable .ag-body-vertical-scroll,
.server-side-datatable .ag-body-vertical-scroll-viewport,
.server-side-datatable .ag-body-vertical-scroll-container {
  width: 10px !important;
  max-width: 10px !important;
  min-width: 10px !important;
}

.server-side-datatable .ag-body-horizontal-scroll,
.server-side-datatable .ag-body-horizontal-scroll-viewport,
.server-side-datatable .ag-body-horizontal-scroll-container {
  height: 10px !important;
  max-height: 10px !important;
  min-height: 10px !important;
}

/* ==========================================================================
   11. TOOLTIPS
   ========================================================================== */
/* Unified tooltip styling to match dark rounded design */
.server-side-datatable .ag-tooltip,
.server-side-datatable .ag-tooltip .ag-tooltip-content,
.server-side-datatable .MuiTooltip-tooltip {
  background: rgba(66, 66, 66, 0.92) !important;
  color: #ffffff !important;
  border-radius: 6px !important;
  padding: 6px 10px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
  font-family: "Poppins", sans-serif !important;
  font-size: 13px !important;
  line-height: 20px !important;
}

/* Optional: tooltip arrow color when used */
.server-side-datatable .MuiTooltip-arrow {
  color: rgba(66, 66, 66, 0.92) !important;
}

/* Constrain tooltip dimensions to prevent layout shifts */
.server-side-datatable .ag-tooltip,
.server-side-datatable .ag-tooltip .ag-tooltip-content {
  max-width: 400px !important;
  max-height: 200px !important;
}

/* Prevent tooltip from affecting grid layout */
.server-side-datatable .ag-tooltip {
  z-index: 9999 !important;
  pointer-events: none !important;
}

/* ==========================================================================
   12. MUI COMPONENT INTEGRATION
   ========================================================================== */
/* Header icon button hover effects */
.server-side-datatable .ag-header-cell .MuiIconButton-root:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.server-side-datatable .ag-header-cell .MuiIconButton-root:hover svg {
  color: #1976d2 !important;
}

/* Active filter/sort icon styling */
.server-side-datatable .ag-header-cell .MuiIconButton-root.active {
  background-color: rgba(25, 118, 210, 0.12) !important;
}

/* ==========================================================================
   13. MEDIA QUERIES (Responsive & Print)
   ========================================================================== */
/* Responsive adjustments */
@media (max-width: 768px) {
  .server-side-datatable .ag-header-cell,
  .server-side-datatable .ag-cell {
    padding: 6px 8px;
    font-size: 12px;
  }

  .server-side-datatable .ag-header-cell-text {
    font-size: 14px;
  }
}

/* Print styles */
@media print {
  .server-side-datatable .ag-row:hover {
    background-color: transparent;
  }

  .server-side-datatable .ag-paging-panel {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/aggrid.css"],"names":[],"mappings":"AAAA;;+EAE+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,4DAA4D;AAC5D;;;;EAIE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+EAE+E;AAC/E,uBAAuB;AACvB;;;EAGE,6CAA6C;EAC7C,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,sCAAsC;AACtC;;;;EAIE,6CAA6C;EAC7C,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,4BAA4B;AAC9B;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;;+EAE+E;AAC/E;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,mFAAmF;AACnF;EACE,6BAA6B;AAC/B;;AAEA;;+EAE+E;AAC/E;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;+EAE+E;AAC/E;EACE,iBAAiB;AACnB;;AAEA,6DAA6D;AAC7D;EACE,6BAA6B;AAC/B;;AAEA;;+EAE+E;AAC/E;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;AACf;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;;+EAE+E;AAC/E;EACE,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;;+EAE+E;;AAE/E,iCAAiC;AACjC;;;;EAIE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,0DAA0D;AAC1D;;;;EAIE,qBAAqB,EAAE,6BAA6B;EACpD,sBAAsB,EAAE,gCAAgC;AAC1D;;AAEA,iBAAiB;AACjB;;;;;;EAME,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;;;;;;EAME,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;;;;;;EAME,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;;;;;;;EAOE,mBAAmB;AACrB;;AAEA,cAAc;AACd;;;;;;EAME,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;;;EAGE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;+EAE+E;AAC/E,yDAAyD;AACzD;;;EAGE,6CAA6C;EAC7C,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,mDAAmD;EACnD,6CAA6C;EAC7C,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C;EACE,wCAAwC;AAC1C;;AAEA,0DAA0D;AAC1D;;EAEE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,+CAA+C;AAC/C;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;;+EAE+E;AAC/E,qCAAqC;AACrC;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,qDAAqD;AACvD;;AAEA;;+EAE+E;AAC/E,2BAA2B;AAC3B;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ==========================================================================\n   1. MAIN LAYOUT & CONTAINERS\n   ========================================================================== */\n.server-side-datatable {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n.server-side-datatable .custom-ag-table-container {\n  flex: 1;\n  min-height: 0;\n  margin-left: 4px;\n  margin-right: 4px;\n}\n\n/* Ensure grid viewports can shrink inside flex containers */\n.server-side-datatable .ag-root-wrapper,\n.server-side-datatable .ag-root,\n.server-side-datatable .ag-body-viewport,\n.server-side-datatable .ag-center-cols-viewport {\n  min-height: 0 !important;\n}\n\n.server-side-datatable .ag-center-cols-viewport {\n  margin-bottom: 17px;\n}\n\n/* ==========================================================================\n   2. TYPOGRAPHY (Global Overrides)\n   ========================================================================== */\n/* Headers Typography */\n.server-side-datatable .ag-header,\n.server-side-datatable .ag-header-cell,\n.server-side-datatable .ag-header .ag-header-cell-text {\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 14px !important;\n  line-height: 24px !important;\n  font-weight: 500 !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n\n/* Cell Typography */\n.server-side-datatable .ag-cell {\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 14px !important;\n  line-height: 24px !important;\n  font-weight: 400 !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n\n/* Menus, Lists, Overlays Typography */\n.server-side-datatable .ag-menu,\n.server-side-datatable .ag-virtual-list-item,\n.server-side-datatable .ag-overlay-loading-center,\n.server-side-datatable .ag-overlay-no-rows-center {\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 14px !important;\n  line-height: 24px !important;\n  font-weight: 400 !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n\n/* ==========================================================================\n   3. TABLE HEADER\n   ========================================================================== */\n.server-side-datatable .table-header {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0px;\n  margin-top: 0px;\n  padding: 0px 8px;\n  min-height: 44px;\n}\n\n.server-side-datatable .ag-header {\n  border-bottom: 2px solid #e0e0e0;\n  font-weight: 600;\n}\n\n.server-side-datatable .ag-header-cell {\n  border-right: 1px solid #e0e0e0;\n  padding: 8px 12px;\n}\n\n.server-side-datatable .ag-header-cell-text {\n  font-weight: 600;\n  font-size: 13px;\n}\n\n/* Aligns header cell label with its content cells */\n.server-side-datatable .ag-header-cell-label {\n  padding-left: 4px !important;\n}\n\n/* Custom sorted column header styling */\n.server-side-datatable .sorted-column-header {\n  background-color: #f0f7ff;\n  font-weight: 700;\n}\n\n/* Sort indicator styling */\n.server-side-datatable .ag-header-cell-sorted-asc .ag-header-cell-text::after,\n.server-side-datatable .ag-header-cell-sorted-desc .ag-header-cell-text::after {\n  margin-left: 4px;\n  font-size: 12px;\n}\n\n/* Resize handle styling */\n.server-side-datatable .ag-header-cell-resize {\n  opacity: 0.5;\n}\n\n.server-side-datatable .ag-header-cell-resize:hover {\n  opacity: 1;\n}\n\n/* ==========================================================================\n   4. ROWS\n   ========================================================================== */\n.server-side-datatable .ag-row {\n  border-bottom: 1px solid #f0f0f0;\n  transition: background-color 0.2s ease;\n}\n\n.server-side-datatable .ag-row:hover {\n  background-color: #f8f9fa;\n}\n\n.server-side-datatable .ag-row.ag-row-selected {\n  background-color: #e3f2fd;\n}\n\n.server-side-datatable .ag-row.ag-row-selected:hover {\n  background-color: #bbdefb;\n}\n\n.server-side-datatable .ag-row-last {\n  /* No styles provided, keeping selector */\n}\n\n/* Duplicate rule from input - likely intended to be removed or specific override */\n.server-side-datatable .ag-row:hover {\n  background-color: transparent;\n}\n\n/* ==========================================================================\n   5. CELLS\n   ========================================================================== */\n.server-side-datatable .ag-cell {\n  border-right: 1px solid #f0f0f0;\n  padding: 8px 12px;\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.server-side-datatable .ag-cell.ag-cell-value.text-center {\n  justify-content: center;\n}\n\n.server-side-datatable .ag-cell.ag-cell-value.text-right {\n  justify-content: flex-end;\n}\n\n/* ==========================================================================\n   6. SELECTION (CHECKBOXES)\n   ========================================================================== */\n.server-side-datatable .ag-selection-checkbox {\n  margin-right: 8px;\n}\n\n/* Selection column header alignment with its content cells */\n.server-side-datatable .ag-header-cell[col-id=\"ag-Grid-SelectionColumn\"] {\n  padding-left: 13px !important;\n}\n\n/* ==========================================================================\n   7. PAGINATION\n   ========================================================================== */\n.server-side-datatable .ag-paging-panel {\n  border-top: 1px solid #e0e0e0;\n  background-color: #fafafa;\n  padding: 8px 12px;\n}\n\n.server-side-datatable .ag-paging-button {\n  border: 1px solid #ddd;\n  background-color: white;\n  margin: 0 2px;\n  border-radius: 3px;\n  padding: 4px 8px;\n  font-size: 12px;\n}\n\n.server-side-datatable .ag-paging-button:hover:not(.ag-disabled) {\n  background-color: #f5f5f5;\n}\n\n.server-side-datatable .ag-paging-button.ag-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Duplicate rule from input */\n.server-side-datatable .ag-paging-panel {\n  display: none;\n}\n\n/* ==========================================================================\n   8. OVERLAYS (LOADING & EMPTY)\n   ========================================================================== */\n.server-side-datatable .loading-overlay {\n  position: relative;\n  z-index: 100;\n}\n\n.server-side-datatable .ag-overlay-loading-wrapper {\n  background-color: rgba(255, 255, 255, 0.9);\n}\n\n.server-side-datatable .ag-overlay-loading-center {\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.server-side-datatable .ag-overlay-no-rows-wrapper {\n  background-color: rgba(255, 255, 255, 0.9);\n}\n\n.server-side-datatable .ag-overlay-no-rows-center {\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 20px;\n  font-size: 14px;\n  color: #666;\n}\n\n/* ==========================================================================\n   9. MENUS & FILTERS\n   ========================================================================== */\n.server-side-datatable .ag-menu {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  background-color: white;\n}\n\n.server-side-datatable .ag-menu-option {\n  padding: 8px 12px;\n  font-size: 13px;\n}\n\n.server-side-datatable .ag-menu-option:hover {\n  background-color: #f5f5f5;\n}\n\n.server-side-datatable .ag-filter-toolpanel {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.server-side-datatable .ag-column-drop {\n  background-color: #f8f9fa;\n  border: 1px dashed #ddd;\n  border-radius: 4px;\n  padding: 8px;\n  margin: 4px 0;\n}\n\n/* ==========================================================================\n   10. SCROLLBARS (Thinner & Solid Background)\n   ========================================================================== */\n\n/* 1. Firefox - Thin scrollbars */\n.server-side-datatable .ag-body-viewport,\n.server-side-datatable .ag-center-cols-viewport,\n.server-side-datatable .ag-body-horizontal-scroll-viewport,\n.server-side-datatable .ag-body-vertical-scroll-viewport {\n  scrollbar-width: thin;\n  scrollbar-color: #c1c1c1 #f1f1f1;\n}\n\n/* 2. Webkit - Target specific AG Grid viewport elements */\n.server-side-datatable .ag-body-viewport::-webkit-scrollbar,\n.server-side-datatable .ag-body-horizontal-scroll-viewport::-webkit-scrollbar,\n.server-side-datatable .ag-body-vertical-scroll-viewport::-webkit-scrollbar,\n.server-side-datatable .ag-center-cols-viewport::-webkit-scrollbar {\n  width: 8px !important; /* Vertical scrollbar width */\n  height: 8px !important; /* Horizontal scrollbar height */\n}\n\n/* 3. The Track */\n.server-side-datatable .ag-body-viewport::-webkit-scrollbar-track,\n.server-side-datatable\n  .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track,\n.server-side-datatable\n  .ag-body-vertical-scroll-viewport::-webkit-scrollbar-track,\n.server-side-datatable .ag-center-cols-viewport::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n/* 4. The Thumb - The draggable part */\n.server-side-datatable .ag-body-viewport::-webkit-scrollbar-thumb,\n.server-side-datatable\n  .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb,\n.server-side-datatable\n  .ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb,\n.server-side-datatable .ag-center-cols-viewport::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n/* 5. Hover State */\n.server-side-datatable .ag-body-viewport::-webkit-scrollbar-thumb:hover,\n.server-side-datatable\n  .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb:hover,\n.server-side-datatable\n  .ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb:hover,\n.server-side-datatable .ag-center-cols-viewport::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* 6. Active/Drag State */\n.server-side-datatable .ag-body-viewport::-webkit-scrollbar-thumb:active,\n.server-side-datatable\n  .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb:active,\n.server-side-datatable\n  .ag-body-vertical-scroll-viewport::-webkit-scrollbar-thumb:active,\n.server-side-datatable\n  .ag-center-cols-viewport::-webkit-scrollbar-thumb:active {\n  background: #7d7d7d;\n}\n\n/* 7. Corner */\n.server-side-datatable .ag-body-viewport::-webkit-scrollbar-corner,\n.server-side-datatable\n  .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-corner,\n.server-side-datatable\n  .ag-body-vertical-scroll-viewport::-webkit-scrollbar-corner,\n.server-side-datatable .ag-center-cols-viewport::-webkit-scrollbar-corner {\n  background: #f1f1f1;\n}\n\n/* 8. Force AG Grid scrollbar container sizes */\n.server-side-datatable .ag-body-vertical-scroll,\n.server-side-datatable .ag-body-vertical-scroll-viewport,\n.server-side-datatable .ag-body-vertical-scroll-container {\n  width: 10px !important;\n  max-width: 10px !important;\n  min-width: 10px !important;\n}\n\n.server-side-datatable .ag-body-horizontal-scroll,\n.server-side-datatable .ag-body-horizontal-scroll-viewport,\n.server-side-datatable .ag-body-horizontal-scroll-container {\n  height: 10px !important;\n  max-height: 10px !important;\n  min-height: 10px !important;\n}\n\n/* ==========================================================================\n   11. TOOLTIPS\n   ========================================================================== */\n/* Unified tooltip styling to match dark rounded design */\n.server-side-datatable .ag-tooltip,\n.server-side-datatable .ag-tooltip .ag-tooltip-content,\n.server-side-datatable .MuiTooltip-tooltip {\n  background: rgba(66, 66, 66, 0.92) !important;\n  color: #ffffff !important;\n  border-radius: 6px !important;\n  padding: 6px 10px !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 13px !important;\n  line-height: 20px !important;\n}\n\n/* Optional: tooltip arrow color when used */\n.server-side-datatable .MuiTooltip-arrow {\n  color: rgba(66, 66, 66, 0.92) !important;\n}\n\n/* Constrain tooltip dimensions to prevent layout shifts */\n.server-side-datatable .ag-tooltip,\n.server-side-datatable .ag-tooltip .ag-tooltip-content {\n  max-width: 400px !important;\n  max-height: 200px !important;\n}\n\n/* Prevent tooltip from affecting grid layout */\n.server-side-datatable .ag-tooltip {\n  z-index: 9999 !important;\n  pointer-events: none !important;\n}\n\n/* ==========================================================================\n   12. MUI COMPONENT INTEGRATION\n   ========================================================================== */\n/* Header icon button hover effects */\n.server-side-datatable .ag-header-cell .MuiIconButton-root:hover {\n  background-color: rgba(0, 0, 0, 0.04) !important;\n}\n\n.server-side-datatable .ag-header-cell .MuiIconButton-root:hover svg {\n  color: #1976d2 !important;\n}\n\n/* Active filter/sort icon styling */\n.server-side-datatable .ag-header-cell .MuiIconButton-root.active {\n  background-color: rgba(25, 118, 210, 0.12) !important;\n}\n\n/* ==========================================================================\n   13. MEDIA QUERIES (Responsive & Print)\n   ========================================================================== */\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .server-side-datatable .ag-header-cell,\n  .server-side-datatable .ag-cell {\n    padding: 6px 8px;\n    font-size: 12px;\n  }\n\n  .server-side-datatable .ag-header-cell-text {\n    font-size: 14px;\n  }\n}\n\n/* Print styles */\n@media print {\n  .server-side-datatable .ag-row:hover {\n    background-color: transparent;\n  }\n\n  .server-side-datatable .ag-paging-panel {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
